import { render, staticRenderFns } from "./LayoutBlog.vue?vue&type=template&id=78816f14&"
import script from "./LayoutBlog.vue?vue&type=script&lang=js&"
export * from "./LayoutBlog.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBlog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports